<template>
  <div class="admin-page">
    <h2>操作记录</h2>
    <p class="page-hint">提现、退款、关闭分享，以及解绑、停券、追回赠金、取消合伙人和取消分润。只记录功能上线之后的操作。</p>
    <el-table :data="items" v-loading="loading" empty-text="还没有记录">
      <el-table-column label="时间" width="180">
        <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
      </el-table-column>
      <el-table-column prop="operatorName" label="操作人" width="120" />
      <el-table-column label="动作" width="140">
        <template #default="s">{{ actionText(s.row.action) }}</template>
      </el-table-column>
      <el-table-column prop="targetId" label="对象" width="120" />
      <el-table-column prop="note" label="说明" min-width="220" />
    </el-table>
    <div class="pager">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="total"
        :current-page="page"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const ACTION_TEXT = {
  withdraw_approve: '提现通过',
  withdraw_reject: '提现拒绝',
  withdraw_paid: '提现打款',
  refund_approve: '退款同意',
  refund_reject: '退款拒绝',
  refund_need_info: '退款补充材料',
  revoke_exam_share: '关闭测评分享',
  revoke_binding: '解除礼券绑定',
  disable_coupon: '停用礼券',
  clawback_bonus: '追回赠金',
  cancel_partner: '取消臻享资格',
  cancel_commission: '取消分润'
}

export default {
  name: 'AdminActionLog',
  data() {
    return { items: [], total: 0, page: 1, pageSize: 20, loading: false }
  },
  created() {
    this.load()
  },
  methods: {
    actionText(action) {
      return ACTION_TEXT[action] || action || ''
    },
    formatTime(ts) {
      const n = Number(ts || 0)
      if (!n) return ''
      const d = new Date(n * 1000)
      const p = (v) => String(v).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    async load() {
      this.loading = true
      try {
        const token = localStorage.getItem('jwt_token')
        const { data } = await axios.post('/api/v1/admin/action-log/list', {
          page: this.page,
          pageSize: this.pageSize
        }, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
        if (data?.code !== 200) {
          this.$message.error(data?.message || '读取失败')
          return
        }
        this.items = data.data?.items || []
        this.total = Number(data.data?.total || 0)
      } catch (e) {
        this.$message.error(e.message || '读取失败')
      } finally {
        this.loading = false
      }
    },
    changePage(page) {
      this.page = page
      this.load()
    }
  }
}
</script>

<style scoped>
.page-hint { color: #909399; margin: 0 0 16px; }
.pager { margin-top: 16px; display: flex; justify-content: flex-end; }
</style>
